import React from 'react';
import palette from '../../color-palette';

interface SidesProps {
  darkMode: boolean;
}

const Sides = ({ darkMode, ...props }: SidesProps) => {
  const {
    primary: { main },
    common: { white },
  } = palette;

  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.65 13.07a.17.17 0 0 0-.13-.06h-1.54l.57-2.63a.85.85 0 0 0-.65-1l-.93-.21V7a.96.96 0 0 0-.96-.93h-.11a.99.99 0 0 0-1 .99v.34l-.23-.08a1.03 1.03 0 0 0-1.21.78l-1.58-.35a.97.97 0 0 0-.9-.76l.3-.93a1.07 1.07 0 0 0-.7-1.34 1.1 1.1 0 0 0-1.4.72l-.73 2.33-.03-.71a1.03 1.03 0 0 0-1.01-1h-.07a1.03 1.03 0 0 0-1.02 1.06l.04 1.25-.81.14a1.2 1.2 0 0 0-.9.73h-.81a.79.79 0 0 0-.78.8v1.7l-.24-.15a.77.77 0 0 0-1.04.16l-.14.19A.81.81 0 0 0 5.71 13H4.48a.17.17 0 0 0-.16.13v.08a14.78 14.78 0 0 0 2.39 5.33 23 23 0 0 0 3.32 3.85h.04v1.2a.17.17 0 0 0 .1.16l.07.01h7.68a.17.17 0 0 0 .17-.17v-1.3a24.98 24.98 0 0 0 3.2-3.77 14.78 14.78 0 0 0 2.4-5.34.18.18 0 0 0-.04-.12Zm-2.6-3.53.78.18a.47.47 0 0 1 .37.59l-.57 2.7h-1.46l.87-3.47Zm-5.14-1.4 1.48.33-.49 2.54a1.01 1.01 0 0 0-.24 1.33l-.13.64h-.75l.13-4.84Zm1 4.6.21.27h-.26l.05-.27Zm.67.27-.59-.71a.17.17 0 0 0-.03-.07.67.67 0 0 1 .08-.89l.04-.03a.22.22 0 0 1 .07-.04.62.62 0 0 1 .8.1l.72.84.65.76-1.74.04Zm2.27-6.62h.1a.6.6 0 0 1 .62.61l.02 2.86-.78 3.11-.8-.93.62-3.6a.93.93 0 0 0-.42-.94v-.47a.64.64 0 0 1 .64-.64Zm-2.04 1.8a.66.66 0 0 1 .3-.42.7.7 0 0 1 .5-.1l.22.05a.59.59 0 0 1 .46.67l-.57 3.32-.52-.57a.97.97 0 0 0-.93-.31l.54-2.63Zm-2.23-.18-.16 4.98H14L14.2 8a.7.7 0 0 1 .7-.68h.03c.18 0 .35.08.47.2a.65.65 0 0 1 .18.48Zm-2.9 4.98-.2-4.9h1.33l-.18 4.9h-.95Zm.87-7.47a.75.75 0 0 1 1.18-.33c.07.06.12.13.17.22a.67.67 0 0 1 .03.52l-.35 1.1a1.05 1.05 0 0 0-.72.7h-1.03l.72-2.2Zm-2.7 1.07c.13-.12.3-.2.48-.2h.06a.69.69 0 0 1 .68.66l.06.88.21 5.04h-1.48l-.2-5.89a.67.67 0 0 1 .2-.48ZM9.62 8.83l.76-.13.14 4.28H9.3l-.38-3.23a.84.84 0 0 1 .68-.91Zm-1.77.75h.74v.21l.36 3.2h-.07L7.4 11.98v-1.96a.43.43 0 0 1 .43-.44ZM6.02 12.8a.46.46 0 0 1-.2-.31.47.47 0 0 1 .1-.34l.14-.18a.41.41 0 0 1 .57-.1l.46.33 1.12.77H6.28l-.26-.17Zm11.71 10.64h-7.31v-1h7.31v1Zm3.27-5.1a24.43 24.43 0 0 1-3.22 3.76h-7.57A24.43 24.43 0 0 1 7 18.33a14.93 14.93 0 0 1-2.28-5H23.3a14.94 14.94 0 0 1-2.3 5Z"
        fill={darkMode ? white : main}
      />
    </svg>
  );
};

export default Sides;
